export default {
	mounted() {
		let title = this.title;
		if (title) {
			title = typeof title === 'function' ? title.call(this) : title;
			document.title = `${title} - みんなで翻刻｜歴史資料の参加型翻刻プラットフォーム`;
		}
	}
};
